import React from 'react';
import '../styles/roomDetail.css';

const RoomOverview = ({ language, title, overview, highlights = [] }) => {
  return (
    <section className="room-overview py-5">
      <div className="container">
        <h2 className="room-section-title mb-3">
          {title?.[language] || (language === 'en' ? 'Overview' : 'እይታ')}
        </h2>
        <p className="room-overview-text mb-4">
          {overview[language]}
        </p>
        {highlights.length > 0 && (
          <div className="row g-3">
            {highlights.map((item, idx) => (
              <div className="col-md-6" key={idx}>
                <div className="room-highlight">
                  <span className="room-highlight-dot" />
                  <span>{item[language]}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default RoomOverview;
